import { CustomFieldType } from '__types__';
import { stringFilterSchema } from 'v5/api/_common/query/filters/StringFilter';
import { CustomFieldAnyFilter } from './custom-fields-filters.types';
import { enumFilterSchema } from 'v5/api/_common/query/filters/EnumFilter';
import { numberFilterSchema } from 'v5/api/_common/query/filters/NumberFilter';
import { booleanFilterSchema } from 'v5/api/_common/query/filters/BooleanFilter';
import z from 'zod';
import { customFilter } from '../standard-date-filter/custom-filter';

export const customFieldSchemas = {
  SHORT_TEXT: stringFilterSchema,
  LONG_TEXT: stringFilterSchema,
  URL: stringFilterSchema,
  NUMBER: numberFilterSchema,
  PERCENTAGE: numberFilterSchema,
  BOOLEAN: booleanFilterSchema,
  DATE: customFilter.schema,
  DATE_RANGE: customFilter.schema, // for now we do not support presets for date ranges when parsing
  SINGLE_SELECT: enumFilterSchema(z.string()),
  MULTI_SELECT: enumFilterSchema(z.string()),
  CURRENCY: numberFilterSchema,
  MEASUREMENT: numberFilterSchema,
  MEASUREMENT_NEW: numberFilterSchema,
  DIMENSION_2D: numberFilterSchema,
  DIMENSION_3D: numberFilterSchema,
  HEIGHT: numberFilterSchema,
  NETSUITE_MASTER_PROJECT: stringFilterSchema,
  NETSUITE_PO: stringFilterSchema,
  NETSUITE_VENDOR: stringFilterSchema,
  NETSUITE_SUBCLASS: stringFilterSchema
} as const satisfies Record<CustomFieldType, z.ZodSchema<CustomFieldAnyFilter>>;

export const customFieldFiltersSchema = z.record(
  z.string().regex(/^custom_.+/),
  z.union(Object.values(customFieldSchemas))
);

export const withCustomFieldFiltersSchema = <Z extends z.ZodObject<any>>(
  filtersObjectSchema: Z
) => {
  return z
    .object({})
    .merge(filtersObjectSchema)
    .catchall(z.union(Object.values(customFieldSchemas)).nullable().optional())
    .superRefine((obj, ctx) => {
      for (const key in obj) {
        if (!filtersObjectSchema.shape[key] && !key.startsWith('custom_')) {
          ctx.addIssue({
            code: 'custom',
            message: `Invalid field: ${key} is not a valid custom field and is not supported by the base schema`,
            path: [key]
          });
        }
      }
    });
};
